export const LOADING = 'waitrose/taxonomy/LOADING';
export const LOADED = 'waitrose/taxonomy/LOADED';
export const FAILED = 'waitrose/taxonomy/FAILED';

export const FOOTER_LOADING = 'waitrose/taxonomy/footer/LOADING';
export const FOOTER_LOADED = 'waitrose/taxonomy/footer/LOADED';
export const FOOTER_FAILED = 'waitrose/taxonomy/footer/FAILED';
